if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.dots = this.querySelector('.gallery-dots');
      if (this.dots) {
        this.dotEls = this.dots.querySelectorAll('.gallery-dot');
        this.elements.viewer.addEventListener('slideChanged', this.updateDots.bind(this));
      }

      this.initGalleryNav();

      // Fetch the images next to the active one right away, and keep doing so
      // as the visitor moves through the gallery (swipe on mobile, arrows and
      // thumbnails on desktop), so the next image is already there.
      this.warmUpNeighbours(this.elements.viewer.querySelector('.product__media-item.is-active'));
      this.elements.viewer.addEventListener('slideChanged', (event) => this.warmUpNeighbours(event.detail.currentElement));

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        mediaToSwitch.addEventListener('mouseenter', () => {
          this.warmUpMedia(this.elements.viewer.querySelector(`[data-media-id="${ mediaToSwitch.dataset.target }"]`));
        }, { passive: true });
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    initGalleryNav() {
      const prevBtn = this.querySelector('.product-gallery-nav__btn--prev');
      const nextBtn = this.querySelector('.product-gallery-nav__btn--next');
      if (!prevBtn || !nextBtn) return;

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigateGallery(-1);
      });
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.navigateGallery(1);
      });
    }

    navigateGallery(direction) {
      const mediaItems = Array.from(
        this.elements.viewer.querySelectorAll('.product__media-item:not(.product__media-item--variant-hidden)')
      ).filter(item => {
        // On mobile, all items are in the scroll; on desktop thumbnail, only is-active is visible
        // We want all navigable items regardless
        return item.dataset.mediaId;
      });

      if (mediaItems.length < 2) return;

      // Find the currently active item
      let currentIndex = mediaItems.findIndex(item => item.classList.contains('is-active'));
      if (currentIndex === -1) currentIndex = 0;

      // Calculate target index with wrapping
      let targetIndex = currentIndex + direction;
      if (targetIndex < 0) targetIndex = mediaItems.length - 1;
      if (targetIndex >= mediaItems.length) targetIndex = 0;

      const targetItem = mediaItems[targetIndex];
      const targetMediaId = targetItem.dataset.mediaId;
      this.warmUpMedia(targetItem);
      this.warmUpNeighbours(targetItem);

      if (this.mql.matches && this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail')) {
        // Desktop with thumbnails: use setActiveMedia (shows/hides via is-active class)
        this.setActiveMedia(targetMediaId, false);
      } else {
        // Mobile or non-thumbnail desktop: scroll the slider
        if (this.elements.viewer.slider) {
          targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        // Also update is-active for non-thumbnail layouts
        mediaItems.forEach(item => item.classList.remove('is-active'));
        targetItem.classList.add('is-active');
        this.playActiveMedia(targetItem);
      }

      // Update dots if present
      if (this.dotEls) {
        this.dotEls.forEach((dot, i) => {
          dot.classList.toggle('gallery-dot--active', i === targetIndex);
        });
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      this.warmUpNeighbours(activeMedia);

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
//        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
//          activeMedia.scrollIntoView({behavior: 'smooth'});
//        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    /**
     * On desktop every non-active media item is display:none and its image is
     * lazy, so nothing is fetched until the visitor lands on it – a white frame
     * for as long as the download takes. Switching the image to eager starts
     * the download at once; decode() makes sure it is also ready to paint.
     */
    warmUpMedia(item) {
      if (!item) return;
      item.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
        if (typeof img.decode === 'function') img.decode().catch(() => {});
      });
    }

    warmUpNeighbours(activeItem) {
      if (!activeItem) return;
      const items = Array.from(
        this.elements.viewer.querySelectorAll('.product__media-item:not(.product__media-item--variant-hidden)')
      );
      const index = items.indexOf(activeItem);
      if (index === -1 || items.length < 2) return;
      [index - 1, index + 1].forEach((i) => this.warmUpMedia(items[(i + items.length) % items.length]));
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    updateDots(event) {
      if (!this.dotEls) return;
      var index = event.detail.currentPage - 1;
      this.dotEls.forEach(function(dot, i) {
        dot.classList.toggle('gallery-dot--active', i === index);
      });
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
